export function getDutchiePOSURL() {
  const serverName = window.location.hostname.split('.')[0];
  const { pathname } = window.location;
  const dutchiePOSURLWithPath = `https://${serverName}.backoffice.dutchie.com${pathname}`;

  return dutchiePOSURLWithPath;
}
